export default __webpack_public_path__ + "static/media/unchecked.006df443.svg";